<template>
  <div :class="$style.container">
    <div
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.counterparty },
      ]"
    >
      <p>Заказчик</p>
      <div :class="$style.select">
        <input
          v-model="counterparty"
          @input="getCounterparties"
          type="text"
          placeholder="Введите заказчика"
        />
        <img
          v-if="counterparty"
          @click.stop="select('counterparty', null), (counterparty = '')"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="counterparties.length" :class="$style.options">
        <div
          v-for="i in counterparties"
          :key="i.slug"
          @click="
            select('counterparty', i.id),
              (counterparty = i.name),
              $store.commit('setCounterparties', [])
          "
        >
          {{ i.name }}
        </div>
      </div>
    </div>
    <div :class="[$style.filter, { [$style.error]: errors && errors.name }]">
      <p>Проект</p>
      <div :class="$style.select">
        <input
          v-model="filters.name"
          @input="setName"
          type="text"
          placeholder="Введите проект"
        />
        <img
          v-if="filters.name"
          @click.stop="select('name', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div
      :class="[$style.filter, { [$style.error]: errors && errors.started_at }]"
    >
      <p>Старт</p>
      <div v-if="$route.name === 'projects'" :class="$style.select">
        <div
          :class="{ [$style.selected]: filters.ordering[0] }"
          @click="
            setFilters(
              0,
              filters.ordering[0] === 'started_at'
                ? '-started_at'
                : 'started_at'
            )
          "
        >
          В порядке
          {{
            filters.ordering[0] === "started_at"
              ? "возрастания"
              : filters.ordering[0] === "-started_at"
              ? "убывания"
              : " создания"
          }}
        </div>
        <img v-if="!filters.ordering[0]" src="/icons/arrow-bottom.svg" alt="" />
        <img
          v-if="filters.ordering[0] === '-started_at'"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
        <img
          v-if="filters.ordering[0] === 'started_at'"
          :style="{ transform: 'rotate(180deg)' }"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
      </div>
      <div
        v-else
        :class="[$style.date, { [$style.error]: errors && errors.started_at }]"
      >
        <div :class="[$style.from]" class="before">
          <div :class="[$style.dateValue, { [$style.active]: before }]">
            <img src="/icons/picker.svg" alt="" />
            <p>
              {{
                before
                  ? before.substr(0, 10).split("-").reverse().join(".")
                  : "__.__.____"
              }}
            </p>
            <img
              @click.stop="resetData('before')"
              src="/icons/cross.svg"
              alt=""
            />
          </div>

          <VueCtkDateTimePicker
            id="before"
            ref="before"
            v-model="before"
            autoClose
            locale="ru"
            formatted="DD-MM-YYYY"
            onlyDate
            inputSize="lg"
            color="#34c759"
          />
        </div>
      </div>
    </div>
    <div
      :class="[$style.filter, { [$style.error]: errors && errors.ended_at }]"
    >
      <p>Финиш</p>
      <div v-if="$route.name === 'projects'" :class="$style.select">
        <div
          :class="{ [$style.selected]: filters.ordering[1] }"
          @click="
            setFilters(
              1,
              filters.ordering[1] === 'ended_at' ? '-ended_at' : 'ended_at'
            )
          "
        >
          В порядке
          {{
            filters.ordering[1] === "ended_at"
              ? "возрастания"
              : filters.ordering[1] === "-ended_at"
              ? "убывания"
              : " создания"
          }}
        </div>
        <img v-if="!filters.ordering[1]" src="/icons/arrow-bottom.svg" alt="" />
        <img
          v-if="filters.ordering[1] === '-ended_at'"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
        <img
          v-if="filters.ordering[1] === 'ended_at'"
          :style="{ transform: 'rotate(180deg)' }"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
      </div>
      <div
        v-else
        :class="[$style.date, { [$style.error]: errors && errors.ended_at }]"
      >
        <div :class="[$style.from]" class="from">
          <div :class="[$style.dateValue, { [$style.active]: from }]">
            <img src="/icons/picker.svg" alt="" />
            <p>
              {{
                from
                  ? from.substr(0, 10).split("-").reverse().join(".")
                  : "__.__.____"
              }}
            </p>
            <img
              @click.stop="resetData('from')"
              src="/icons/cross.svg"
              alt=""
            />
          </div>

          <VueCtkDateTimePicker
            id="from"
            ref="from"
            v-model="from"
            autoClose
            locale="ru"
            formatted="DD-MM-YYYY"
            onlyDate
            inputSize="lg"
            color="#34c759"
          />
        </div>
      </div>
    </div>
    <div :class="[$style.filter, { [$style.error]: errors && errors.cost }]">
      <p>Стоимость $</p>
      <div v-if="$route.name === 'projects'" :class="$style.select">
        <div
          :class="{ [$style.selected]: filters.ordering[2] }"
          @click="
            setFilters(2, filters.ordering[2] === 'cost' ? '-cost' : 'cost')
          "
        >
          В порядке
          {{
            filters.ordering[2] === "cost"
              ? "возрастания"
              : filters.ordering[2] === "-cost"
              ? "убывания"
              : " создания"
          }}
        </div>
        <img v-if="!filters.ordering[2]" src="/icons/arrow-bottom.svg" alt="" />
        <img
          v-if="filters.ordering[2] === '-cost'"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
        <img
          v-if="filters.ordering[2] === 'cost'"
          :style="{ transform: 'rotate(180deg)' }"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
      </div>
      <div v-else :class="$style.select">
        <input
          v-model="filters.cost"
          @input="
            $store.commit('setProjectsField', {
              field: 'cost',
              value: filters.cost,
            })
          "
          type="text"
          placeholder="Введите стоимость"
        />
        <img
          v-if="filters.cost"
          @click.stop="select('cost', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div
      :class="[$style.filter, { [$style.error]: errors && errors.readiness }]"
    >
      <p>Готовность %</p>
      <div v-if="$route.name === 'projects'" :class="$style.select">
        <div
          :class="{ [$style.selected]: filters.ordering[3] }"
          @click="
            setFilters(
              3,
              filters.ordering[3] === 'readiness' ? '-readiness' : 'readiness'
            )
          "
        >
          В порядке
          {{
            filters.ordering[3] === "readiness"
              ? "возрастания"
              : filters.ordering[3] === "-readiness"
              ? "убывания"
              : " создания"
          }}
        </div>
        <img v-if="!filters.ordering[3]" src="/icons/arrow-bottom.svg" alt="" />
        <img
          v-if="filters.ordering[3] === '-readiness'"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
        <img
          v-if="filters.ordering[3] === 'readiness'"
          :style="{ transform: 'rotate(180deg)' }"
          src="/icons/arrow-bottom-black.svg"
          alt=""
        />
      </div>
      <div v-else :class="$style.select">
        <input
          v-model="filters.readiness"
          type="text"
          placeholder="Введите готовность"
          @input="
            $store.commit('setProjectsField', {
              field: 'readiness',
              value: filters.readiness,
            })
          "
        />
        <img
          v-if="filters.readiness"
          @click.stop="select('readiness', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div v-if="!forCreation" @click="reset" :class="$style.reset">Сбросить</div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import debounce from "debounce";
export default {
  data() {
    return {
      filters: {
        counterparty: null,
        name: "",
        ordering: ["", "", "", ""],
        cost: "",
        readiness: "",
        from: "",
        before: "",
      },
      isLoad: false,
      errors: [],
      counterparty: "",
      interval: "",
      from: "",
      before: "",
    };
  },
  props: {
    forCreation: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueCtkDateTimePicker,
  },
  async mounted() {
    this.interval = setInterval(async () => {
      this.filters.isNotLoad = true;
      await this.getData();
      this.filters.isNotLoad = false;
    }, 30000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    setFilters(index, value) {
      this.filters.ordering[index] = value;
      let payload = JSON.parse(JSON.stringify(this.filters.ordering));
      payload = payload.filter((i) => i !== "").join(",");
      this.$store.dispatch("getProjects", {
        name: this.name,
        counterparty: this.counterparty,
        ordering: payload,
      });
    },
    setName() {
      if (this.$route.name === "projects") {
        this.getProjects();
      } else {
        this.$store.commit("setProjectsField", {
          field: "name",
          value: this.filters.name,
        });
      }
    },
    select(field, value) {
      if (value) {
        this.filters[field] = value;
        this.$store.commit("setProjectsField", {
          field,
          value: value,
        });
      } else {
        this.filters[field] = "";
        this.$store.commit("setProjectsField", { field, value: "" });
      }
      if (this.$route.fullPath === "/projects") {
        this.getData();
      }
    },
    reset() {
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.filters.ordering = ["", "", "", ""];
      this.getData();
    },
    resetData(key) {
      this.filters[key] = "";
      if (key === "before") {
        this.before = "";
      }
      if (key === "from") {
        this.from = "";
      }

      this.filters.ordering = ["", "", "", ""];
      if (this.$route.name === "projects") {
        this.getData();
      }
    },
    async getData() {
      this.$store.dispatch("getProjects", this.filters);
    },
    getCounterparties: debounce(async function () {
      await this.$store.dispatch("getCounterparties", {
        name: this.counterparty,
      });
    }, 300),
    getProjects: debounce(async function () {
      this.$store.dispatch("getProjects", this.filters);
    }, 300),
  },
  computed: {
    counterparties() {
      return this.$store.state.counterparties.counterparties;
    },
    projects() {
      return this.$store.state.projects.projects;
    },
    project() {
      return this.$store.state.projects.project;
    },
    allErrors() {
      return this.$store.state.errors.errors[0];
    },
  },
  watch: {
    project() {
      if (!this.isLoad) {
        if (this.project.slug) {
          this.filters.name = this.project.name;
          this.filters.cost = this.project.cost;
          this.filters.readiness = this.project.readiness;
          this.counterparty = this.project.counterparty.name;
          this.from = this.project.ended_at;
          this.before = this.project.started_at;
        }
        this.isLoad = true;
      }
    },
    allErrors() {
      this.errors = this.allErrors;
    },
    from() {
      this.from = this.from.substr(0, 10);
      this.$store.commit("setProjectsField", {
        field: "ended_at",
        value: this.from.substr(0, 10),
      });
    },
    before() {
      this.before = this.before.substr(0, 10);
      this.$store.commit("setProjectsField", {
        field: "started_at",
        value: this.before.substr(0, 10),
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  > div {
    width: 100%;
    p {
      @include Body3;
      color: $t-secondary;
      margin: 0 0 0.25rem 0;
    }
  }
  .date {
    .from,
    .before {
      position: relative;
      .dateValue {
        height: 2.5rem;
        @include Subtitle;
        color: $t-secondary;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid $bg-separator;
        gap: 0.5rem;
        border-radius: 0.25rem;
        padding: 0 0.75rem;
        cursor: pointer;
        p {
          flex: 1 1 auto;
          position: relative;
          top: 0.2rem;
        }
        img {
          position: relative;
          z-index: 2;
        }
        &.active {
          p {
            color: $t-primary;
            @include Subtitle;
          }
        }
      }

      input {
        opacity: 0;
      }
      label {
        display: none;
      }
    }
    &.error {
      p {
        color: $red;
      }
      .from {
        .dateValue {
          border: 1px solid $red;
        }
      }
    }
  }
  .filter {
    position: relative;
    .select {
      padding: 0.75rem;
      @include Subtitle;
      color: $t-secondary;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      cursor: pointer;
      div {
        width: 100%;
      }
      div.selected {
        color: $t-primary;
      }
      input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: none;
        background-color: inherit;
        @include Subtitle;
        &::placeholder {
          @include Subtitle;
        }
      }
    }
    .options {
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      position: absolute;
      z-index: 2;
      background-color: $bg-secondary;
      border-bottom: none;
      width: 100%;
      cursor: pointer;
      > div {
        color: $t-secondary;
        @include Subtitle;
        padding: 0.5rem;
        border-bottom: 1px solid $bg-separator;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .dot {
          width: 0.5rem;
          height: 0.5rem;
          flex: 0 0 0.5rem;
          border-radius: 50%;
          &.orange {
            background-color: $orange;
          }
          &.grey {
            background-color: $t-secondary;
          }
          &.green {
            background-color: $main-green;
          }
          &.purple {
            background-color: $purple;
          }
          &.blue {
            background-color: $blue-primary;
          }
          &.red {
            background-color: $red-primary;
          }
        }
      }
    }
    &.error {
      > p {
        color: $red;
      }
      .select {
        border: 1px solid $red;
      }
    }
  }

  .reset {
    background-color: $main-green;
    padding: 0.75rem 0;
    @include Body2;
    border-radius: 0.25rem;
    text-align: center;
    color: $t-white;
  }
}
</style>

<style lang="scss">
.date-time-picker {
  position: absolute;
  top: 0;
  left: 0;
  height: 2.5rem;
  width: 100%;
}
.fs-16 {
  display: none;
}
.custom-button {
  display: none;
}
.datepicker-button-content {
  color: $main-green !important;
}
</style>
